var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChickenLeg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_641_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8095 16.3019C32.7389 19.1567 37.05 18.3404 37.05 21.0859C37.05 23.5935 29.3148 25.1483 26.8011 25.2777L16.3229 25.4727C9.61028 25.4727 4.74609 23.6421 4.74609 18.1413C4.74609 12.6404 9.70861 6.68335 16.8038 6.68335C23.5052 6.68335 30.0997 11.0488 31.8095 16.3019Z",
    fill: "#D87E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4648 18.604C34.0149 18.4156 33.4914 18.5139 33.1495 18.8619C31.345 20.7002 25.556 21.8134 23.4458 21.9219L12.9676 22.1166C9.90188 22.1166 7.22204 21.7345 5.21484 20.7955C6.58346 24.2485 10.8354 25.4726 16.3236 25.4726L26.8018 25.2776C29.3152 25.1485 37.0507 23.5934 37.0507 21.0858C37.0507 19.5933 35.7768 19.1533 34.4648 18.604Z",
    fill: "#C67030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9353 7.01067C34.5648 7.51467 34.6368 8.12496 34.7612 8.54601C34.8565 8.86846 34.74 9.21535 34.4684 9.41311L29.8143 12.7854C29.2477 13.196 29.1235 13.9895 29.5377 14.5536C29.9516 15.1175 30.7459 15.2367 31.3073 14.8189L35.9186 11.3885C36.1888 11.1885 36.5547 11.1814 36.8337 11.3687C37.1982 11.6137 37.7591 11.8653 38.3507 11.6623C39.1263 11.3967 39.4529 10.5362 39.1266 9.78445C38.8701 9.19366 38.3191 8.87643 37.7588 8.87643C37.6382 8.87643 37.5355 8.81628 37.4718 8.72784C37.4067 8.64077 37.38 8.52486 37.416 8.40978C37.5838 7.8753 37.4462 7.25429 36.9593 6.83297C36.3396 6.29629 35.4212 6.35039 34.9353 7.01067Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8406 23.1416C19.7723 25.7725 23.5961 26.2474 26.3811 24.2026C27.6915 23.2404 28.4872 21.9295 28.9871 20.3711C29.6512 18.301 30.6238 16.6324 32.2475 15.1427C32.6584 14.7656 32.7348 14.1619 32.4228 13.7373L31.1805 12.0454C30.8688 11.6205 30.2697 11.5125 29.7872 11.7916C27.8794 12.8946 25.996 13.3231 23.8221 13.3368C22.1857 13.347 20.6965 13.7136 19.3861 14.6758C16.6011 16.7203 15.9092 20.5109 17.8406 23.1416Z",
    fill: "#E88C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4238 13.7372L31.1815 12.0453C31.0813 11.9088 30.8907 11.8401 30.6759 11.8104C30.1016 11.7316 29.5311 11.9681 29.1493 12.4042C27.8494 13.8896 26.5917 15.8377 26.0729 17.4557C25.573 19.0142 24.7771 20.3251 23.4667 21.2872C21.5575 22.6891 19.16 22.9063 17.2188 22.0568C17.3827 22.4339 17.5893 22.7978 17.8419 23.1417C19.7733 25.7724 23.5971 26.2476 26.3822 24.2024C27.6925 23.2406 28.4885 21.9294 28.9881 20.3712C29.6522 18.3011 30.6248 16.6326 32.2486 15.1426C32.6595 14.7657 32.7358 14.162 32.4238 13.7372Z",
    fill: "#D38231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9925 25.0557H5.00744C4.45099 25.0557 4 25.5067 4 26.0631C4 26.6196 4.45099 27.0706 5.00744 27.0706H6.97729C7.22833 27.0706 7.45464 27.2224 7.5494 27.4551L7.89437 28.2991C8.21682 29.0885 8.98476 29.6046 9.83757 29.6046H34.1624C35.0152 29.6046 35.7831 29.0885 36.1056 28.2991L36.4505 27.4551C36.5453 27.2224 36.7716 27.0706 37.0226 27.0706H38.9925C39.5489 27.0706 39.9999 26.6196 39.9999 26.0631C39.9999 25.5067 39.5489 25.0557 38.9925 25.0557Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9921 25.0557H35.8588C35.8588 26.1686 34.9568 27.0706 33.8439 27.0706H33.8197C33.8068 27.0706 33.7942 27.0717 33.7813 27.0719H6.99609C7.23917 27.0796 7.45642 27.2285 7.54898 27.4548L7.83655 28.1585H32.0317C32.0039 28.212 31.9776 28.2667 31.9545 28.3236L31.7087 28.9256C31.5409 29.3362 31.1415 29.6043 30.698 29.6043H34.1619C35.0147 29.6043 35.7827 29.0885 36.1051 28.2991L36.4501 27.4548C36.5451 27.2224 36.7712 27.0706 37.0222 27.0706H38.9921C39.5485 27.0706 39.9995 26.6196 39.9995 26.0631C39.9995 25.5067 39.5485 25.0557 38.9921 25.0557Z",
    fill: "#D8D6D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_290",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_290",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenLeg);
export default __webpack_public_path__ + "static/media/chicken-leg.25b4ecb52177c18ef7a0909efb5cf697.svg";
export { ForwardRef as ReactComponent };